import { animated, config, useTransition } from '@react-spring/web'
import CustomInput from '../../components/custom-input';
import { useAppState } from '../../providers/app-state';
import ProductListItem from "./product-list-item";

const ProductList = ({ products, openSidebar }) => {
    const { state, dispatch } = useAppState();

    const transition = useTransition(products || [], {
        config: config.stiff,
        trail: 700 / products.length,
        from: {
            opacity: 0,
            scale: 0.5,
        },
        enter: {
            opacity: 1,
            scale: 1,
        },
        leave: {
            opacity: 0,
            scale: 0.5,
        }
    })

    return (
        <animated.div
            className="w-full"
        >
            {
                transition((style, item) => {
                    return (
                        <ProductListItem
                            style={style}
                            secondaryCategory={item}
                            openSidebar={openSidebar}
                        />
                    )
                })
            }
            <div
                className="bg-white border-l-8 border-skgBlue p-4 rounded-md shadow-md mt-5 space-y-4"
            >
                <p>Hvis ikke du kunne finde hvad du ledte efter..</p>
                <CustomInput
                    placeholder={"Kommentar"}
                    value={state.repairComment}
                    onChange={e => {
                        dispatch({
                            key: "repairComment",
                            value: e.target.value
                        })
                    }}
                    labelText="Udfyld med anden reparation"
                    as={<textarea />}
                    rows={4}
                />
            </div>
        </animated.div>
    )
}

export default ProductList;